import React from 'react';
import './contentnav.css'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Contentmangementnavss = () => {
     const location = useLocation();
    return ( 
        
                    <section className='cont-nav'>

                    <ul className='list-content-nav'>
                        <Link to="/Event-content_Management-page">
                        <h2
                            className={
                            location.pathname.startsWith("/Event-content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>Featured Events
                        </h2>
                        </Link>

                        <Link to="/Category-content_Management-page">
                        <h2
                           className={
                            location.pathname.startsWith("/Category-content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>Category
                        </h2>
                        </Link>
   
                        <Link to="/About-content_Management-page">
                        <h2
                           className={
                            location.pathname.startsWith("/About-content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>Why choose us
                        </h2>
                        </Link>

                        <Link to="/FAQs_content_Management-page">
                        <h2
                           className={
                            location.pathname.startsWith("/FAQs_content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>FAQs
                        </h2>
                        </Link>

                         <Link to="/Feedback_content_Management-page">
                        <h2
                           className={
                            location.pathname.startsWith("/Feedback_content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>Feedback
                        </h2>
                        </Link>   



                         <Link to="/Navs_content_Management-page">
                        <h2
                           className={
                            location.pathname.startsWith("/Navs_content_Management-page")
                                ? "content-text-nav"
                                : "content-text-nav-non-active"
                            }>Navigations
                        </h2>
                        </Link>    



                    </ul>

                    </section>
     );
}
 
export default Contentmangementnavss;